module.exports = __webpack_public_path__ + "static/media/carousal4.dfb1f917.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousal4.jpg
// module id = 311
// module chunks = 0